import { render } from "./Page-Home.vue?vue&type=template&id=43ffb3cb&scoped=true"
import script from "./Page-Home.vue?vue&type=script&lang=js"
export * from "./Page-Home.vue?vue&type=script&lang=js"

import "./Page-Home.vue?vue&type=style&index=0&id=43ffb3cb&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/guide-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ffb3cb"]])

export default __exports__